import { demosById } from "@/demos/registry";
import type { DemoId } from "@/demos/types";

/** Deep-linking a single demo, so a QR code can point straight at Explore. */
export function initialDemoFromSearch(search: string): DemoId {
  const requested = new URLSearchParams(search).get("demo");
  return requested && requested in demosById ? requested as DemoId : "see";
}

export function replaceDemoInUrl(id: DemoId): void {
  const url = new URL(window.location.href);
  url.searchParams.set("demo", id);
  window.history.replaceState(null, "", url);
}
